import React, { useState } from 'react';
import FlatList from 'flatlist-react/lib';
import './Areas.scss';
import Spinner from '../../Spinner';
import { useUserContext } from '../../../contexts/UserContext';
import MyArea from './MyArea';

export default function MyAreas(props) {
    const {
        getToken
    } = useUserContext();

    const {
        myAreas,
        setMyAreas,
        panel ,
        setPanel,
        map,
        user,
        alerts,
        setAlerts,
        modal,
        setModal
    } = props;
    
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const renderAreaRow = (a) => {
        return (
            <MyArea 
                a={a}
                myAreas={myAreas}
                setAreas={setMyAreas}
                panel={panel} 
                setPanel={setPanel}
                map={map}
                user={user}
                alerts={alerts}
                setAlerts={setAlerts}
                modal={modal}
                setModal={setModal}
            />
        );
    }

    return (
        <div className='all-area-types'>
            <div className='all-area-types-search'>
                <input 
                    type='text'
                    placeholder='Search by address/name'
                    className='all-area-types-search-input'
                    onChange={(e) => setSearch(e.target.value)}
                    />
            </div>
            <div 
                className='all-area-types-new-area-btn'
                onClick={() => {
                    setPanel({
                        name: 'Monitoring Areas - Create',
                        content: null
                    })
                }}    
                >
                Create New Area +
            </div>
            {loading ?
            <Spinner />
            :
            <div className='all-area-types-list'>
                <FlatList
                    list={myAreas.filter((a => a.name.toLowerCase().includes(search.toLowerCase()))).sort((a, b) => 
                        new Date(b.created_timestamp) - new Date(a.created_timestamp)
                      )}
                    renderItem={renderAreaRow}
                    renderOnScroll
                    renderWhenEmpty={() => (
                      <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        padding: '2rem',
                        textAlign: 'center',
                        color: '#666'
                      }}>
                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                          No areas found
                        </div>
                        <div style={{ fontSize: '0.9rem' }}>
                          Try adjusting your search criteria or create a new area
                        </div>
                      </div>
                    )}
                />
            </div>}
        </div>
    )
}